module.exports = __webpack_public_path__ + "img/customer_rewards.bfdf774d.png";